/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_MinInputs */

const en_ui_rail_min = /** @type {(inputs: Ui_Rail_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const de_ui_rail_min = /** @type {(inputs: Ui_Rail_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

/**
* | output |
* | --- |
* | "min" |
*
* @param {Ui_Rail_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_min = /** @type {((inputs?: Ui_Rail_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_min(inputs)
	return de_ui_rail_min(inputs)
});